<template>
  <vx-card :title="`السؤال ${number + 1}`" no-shadow card-border>
    <div slot="actions">
      <div v-if="viewMark" :class="[answer.mark !== null ? 'border-primary' : 'border-danger', 'flex items-center px-4 py-2 rounded-full border border-solid border-primary']">
        <span class="mr-1 font-bold">{{question.mark}} / </span>
        <vs-input-number v-if="question.type === 'plain' && isTeacher" v-model="answer.mark" min="0" :max="question.mark" />
        <span v-else class="text-xl"> {{answer.mark || 0}} </span>
      </div>
    </div>
    <text-editor-viewer class="text-xl" :data="question.title"/>
    <vs-alert v-if="!answer.answer" color="danger" active>لم تقم بالإجابة عن هذا السؤال</vs-alert>
      <div v-if="question.type === 'plain'">
        <vx-card v-if="answer.answer" title="الإجابة" no-shadow card-border>
          <text-editor-viewer class="mb-2" :data="answer.answer" />
          <template v-if="isTeacher">
            <div @click="answer.teacher_comment = ''"
                 v-if="answer.teacher_comment === null"
                 class="flex items-center mb-4 text-lg text-primary hover:underline cursor-pointer">
              <span>أضف ملاحظة</span>
              <feather-icon icon="MessageCircleIcon" class="ml-2" svg-classes="h-5 w-5" />
            </div>
            <div v-else class="lg:w-1/2">
              <div class="flex items-center justify-between mb-2">
                <label>أكتب ملاحظه علي الإجابة</label>
                <vs-button @click="answer.teacher_comment = null"
                           color="danger" type="flat" icon="icon-x" icon-pack="feather" radius title="إزالة التعليق" />
              </div>
              <textarea-autosize dir="auto" v-model="answer.teacher_comment" color="mt-2" />
            </div>
          </template>
          <template v-else-if="answer.teacher_comment">
            <h4 class="mt-4">ملاحظة</h4>
            <p>{{answer.teacher_comment}}</p>
          </template>
        </vx-card>
      </div>
      <ul v-else>
        <li v-for="(choice, index) in question.choices" :key="`${question.id}-${index}`"
            :class="[isRightAnswer(index), 'flex h-16 p-4 mt-4 items-center justify-between border-solid rounded-lg']">
          <span>{{choice.choice_title}}</span>
          <vs-chip v-if="answer.answer != question.answer && question.answer == index" class="m-0" color="success">الإجابة الصحيحة</vs-chip>
        </li>
      </ul>

  </vx-card>
</template>

<script>
    import TextEditorViewer from '@/views/components/TextEditorViewer'
    export default {
        name: 'QuizQuestionItem',
      components: { TextEditorViewer },
      props: {
            number: {
                type: Number,
                default: 0,
            },
            question: {
                type: Object,
                required: true
            },
            answer: {
                type: Object,
                default: () => {},
            },
            viewMark: {
                type: Boolean,
                default: true,
            }
        },
        methods: {
            isRightAnswer(index){
                if(parseInt(this.answer.answer) === index) {
                    if(this.question.answer === undefined) {
                        return 'border-1 border-primary'
                    } else if(index === parseInt(this.question.answer)){
                        return 'border-1 border-success'
                    } else {
                        return 'border-1 border-danger'
                    }
                } else {
                    return 'border border-grey'
                }
            }
        },
        mounted() {
            if(!this.answer.mark) this.answer.mark = 0
        }
    }
</script>
